<template>
  <div>
    <div class="section" :style="isLoading ? {visibility: 'visible'} : {visibility: 'hidden'}">
      <div class="gr-section-wrapper gr-section-wrapper-lg-row gr-sm-scrollable" :style="paddingTop">
        <div class="gr-content-container gr-scrollable gr-order-text" :style="sectionHeight">
          <div class="gr-text-container gr-text-container-lg-column px-4 px-lg-5" :style="paddingY">
            <transition name="slide-fade" appear>
              <div id="gr-goldschmiede">
                <h1 class="gr-header-2">Goldschmiede</h1>
                <div class="gr-p-container" v-reveal>
                  <p>Nach unserer Ausbildung zur Goldschmiedin eröffneten wir im Januar 2011 gemeinsam die Goldschmiede
                    Goldregen in der Belgradstraße.
                    Nach wie vor arbeiten wir mit viel Leidenschaft an unserem Schmuck und
                    freuen uns über alle Kunden, die diese Leidenschaft mit uns teilen.</p>
                  <p>
                    All unsere Schmuckstücke werden in unserer <b>Ladenwerkstatt in München-Schwabing von Hand
                    gefertigt</b>. Bei einem Besuch können Sie sich unseren Schmuck ansehen und bekommen gleichzeitig
                    einen Einblick in das traditionsreiche Handwerk des Goldschmieds, da unsere Werktische direkt im
                    Laden stehen.</p>
                  <p>Die liebevoll gearbeiteten Unikate der Goldschmiede Goldregen Kollektion vereinen Elemente von
                    Antike oder Jugendstil mit einer jungen, zeitgenössischen Formensprache. Unsere Kollektion umfasst
                    Ringe, Ohrringe, Ketten, Armbänder und Manschettenknöpfe.</p>
                  <p> Natürlich fertigen wir auch Schmuckstücke ganz nach Ihren Vorstellungen an, beispielsweise
                    individuelle Verlobungsringe und Eheringe. Von der Wahl des Edelmetalles (Gold, Weißgold, Silber
                    oder Platin) bis zum passenden Edelstein: Ihre Idee trifft auf unsere Fachkompetenz und so entsteht
                    ein ganz persönliches Schmuckunikat.</p>
                  <p> Sehr gerne übernehmen wir auch Umarbeitungen und Reparaturen an Ihrem Schmuck. In jedem Fall steht
                    eine umfassende Fachberatung an erster Stelle.</p>
                  <p> Wir freuen uns sehr, Sie bald in unserer Ladenwerkstatt in der Belgradstrasse 136 begrüßen zu
                    dürfen.</p>
                  <p> Lisa Marx & Katharina Leibold</p>
                </div>
                <gr-btn-lite text="zurück" backgroundColor="rose" @click.native="$routeBack()"></gr-btn-lite>
              </div>
            </transition>
          </div>
        </div>
        <div>
          <img class="gr-main-img gr-order-img" src="@/assets/imgs/goldregen_team.jpg"
               alt="Goldregen Inhaber - Lisa Marx & Katharina Leibold" v-on:load="imageDownloadFinished(1)">
        </div>
      </div>
    </div>
    <div class="section fp-auto-height">
      <AppFooter backgroundColor="rose"></AppFooter>
    </div>
  </div>
</template>

<script>

import AppFooter from './../../layout/Footer'
import grBtnLite from '@/components/grBtnLite'
import { timeout } from '@/config'

export default {
  name: 'Goldschmiede',

  components: {
    grBtnLite,
    AppFooter
  },
  data () {
    return {
      isNewLoading: true,
      isImageLoading1: true,
      imgContainerHeight: 0,
      textContainerHeight: 0,
      window: {
        width: 0,
        height: 0
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.isNewLoading = true
    this.setLoading(true)
  },
  mounted () {
    document.body.style.height = 'auto'
    this.handleResize()
  },
  beforeMount () {
    this.isNewLoading = false
    setTimeout(() => this.setLoading(false), timeout.smallTimeout)
  },
  beforeDestroy () {
    this.$store.commit('setHeader', true)
  },
  computed: {
    paddingTop () {
      if (this.isDesktop) {
        return { padding: '50px 0 0 0 !important' }
      } else {
        return { padding: Math.round(this.$store.getters['dom/navBarHeight'] - 3) + 'px 0 0 0 !important' }
      }
    },
    isDesktop: function () {
      return this.$store.getters['dom/isDesktop']
    },
    isLoading: function () {
      return !this.$store.getters['loading/isLoadingApp']
    },
    sectionHeight () {
      return this.isDesktop && { 'min-height': Math.max(Math.round(this.window.height - 50), document.getElementById('gr-goldschmiede')?.clientHeight + 60) + 'px !important' }
    },
    paddingY () {
      return !this.isDesktop && {
        'padding-top': '45px !important',
        'padding-bottom': '45px !important'
      }
    }
  },
  methods: {
    imageDownloadFinished (id) {
      this.isImageLoading1 = false
      setTimeout(() => {
        this.setLoading(false)
      }, 400)
    },
    setLoading (isLoaded) {
      if ((this.isImageLoading1 && this.isNewLoading) ||
          (!this.isImageLoading1 && !this.isNewLoading)) {
        this.$store.commit('loading/SET_LOADING_APP', isLoaded)
      }
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
      if (this.window.width < 992) {
        this.imgContainerHeight = this.window.height * 0.35
        this.textContainerHeight = (this.window.height - 80) * 0.65
      } else {
        this.imgContainerHeight = this.window.height * 0.40
        this.textContainerHeight = (this.window.height - 110) * 0.60
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  p {
    margin-bottom: 12px;
  }

  b {
    font-weight: 500;
  }

  .gr-order-img {
    order: 1;
  }

  .gr-order-text {
    order: 2;
  }

  .gr-section-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: $color-gr-rose;
  }

  .gr-text-container {
    line-height: 1.1;
  }

  .gr-p-container {
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 0.95em;
    line-height: 1.8;
  }

  .gr-main-img {
    object-fit: cover;
    object-position: 100% 50%;
    width: 100%;
    height: 35vh;
  }
  @media(max-height: 820px) {
    .gr-scrollable {
      min-height: 700px !important;
    }
  }

  @media(min-width: 760px) {
    .gr-text-container-lg-column {
      max-width: 80vw;
      // prevent that on transition potential image below text-container moves
      min-height: 25vh;
    }
    .gr-p-container {
      margin-bottom: 1rem;
    }
  }

  @media(min-width: 760px) and (max-width: 1025px) {
    .gr-text-container {
      max-width: 80vw !important;
      min-height: 25vh !important;
    }
    .gr-order-img {
      order: 1;
    }
    .gr-order-text {
      order: 2;
    }

  }

  @media(max-width: 1023px) {
    .gr-scrollable {
      min-height: 700px !important;
    }
  }

  @media(min-width: $window-lg) {
    .gr-order-img {
      order: 2;
    }
    .gr-order-text {
      order: 1;
    }
    .gr-scrollable {
      max-height: 100vh;
    }
    .gr-text-container-lg-column {
      min-height: 35vh;
    }
    .gr-section-wrapper-lg-row {
      flex-direction: row;
      justify-content: flex-start;
    }
    p {
      font-size: 1.1em;
    }
    .gr-main-img {
      object-position: 40% 100%;
      width: 40vw;
      height: 100%;
      flex: 1;
    }
  }
</style>
